import React from 'react';

const LinkedInIcon = ({ width = 40, height = 41, fill = '#231F20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6271 10.8548C12.6266 11.9405 11.9679 12.9174 10.9616 13.325C9.95538 13.7326 8.80246 13.4895 8.04654 12.7102C7.29061 11.9309 7.08265 10.7711 7.52069 9.77766C7.95875 8.78427 8.95534 8.15565 10.0405 8.18822C11.4819 8.23148 12.6277 9.41275 12.6271 10.8548ZM12.7071 15.4945H7.37401V32.187H12.7071V15.4945ZM21.1334 15.4945H15.8269V32.187H21.08V23.4274C21.08 18.5477 27.4397 18.0944 27.4397 23.4274V32.187H32.7061V21.6142C32.7061 13.388 23.2933 13.6946 21.08 17.7344L21.1334 15.4945Z"
        fill={fill}
      />
    </svg>
  );
};

export default LinkedInIcon;
